import React from "react";
import "./Memories.css";
import ImageSlider from "../../../theme/imageSlider/ImageSlider"; // Import your ImageSlider component
import { memories } from "../../../config/constants";

const Memories = () => {
  return (
    <div className="container memories-container">
      <h3 className="memories-section-name">Memories</h3>
      <div className="inner-container-first nostalgia-slider-container">
        <ImageSlider slideImages={memories} />
      </div>
    </div>
  );
};

export default Memories;
